"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLoading = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var model_1 = require("../../../model");
var dashboardContexts_1 = require("../../dashboardContexts");
var DashboardInner_1 = require("./DashboardInner");
exports.DashboardLoading = function (props) {
    var _a = model_1.useDashboardSelector(model_1.selectDashboardLoading), loading = _a.loading, error = _a.error, result = _a.result;
    var _b = dashboardContexts_1.useDashboardComponentsContext(), ErrorComponent = _b.ErrorComponent, LoadingComponent = _b.LoadingComponent;
    if (error) {
        return react_1.default.createElement(ErrorComponent, { message: error.message });
    }
    if (loading || !result) {
        return react_1.default.createElement(LoadingComponent, null);
    }
    return react_1.default.createElement(DashboardInner_1.DashboardInner, tslib_1.__assign({}, props));
};
//# sourceMappingURL=DashboardLoading.js.map